import { useState, useEffect } from "react";
import { sha1, parseQueryParams } from "utils/misc";
import { useUser } from "utils/hooks";

export default function useVideoUrls(video) {
  const [urls, setUrls] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const { user, token } = useUser();

  async function fetchUrls(video, token) {
    const u = new URL(video.fileUrl);
    const query = parseQueryParams(u.search);
    const parts = u.pathname.split("/");
    const id = parts[parts.length - 1] ?? "";
    setLoading(true);
    
    const hash = await sha1(id + "_" + query.expires + "_" + process.env.FRONTEND_CONTENT_HASH);
    const headers = { "X-Version": hash };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const downloadName = `Iwara - ${video.title} [${video.id}].mp4`;
    u.searchParams.set("download", downloadName);

    const response = await fetch(u.href, { headers });

    const data = await response.json();

    if (response.ok) {
      setUrls(data);
      setError(null);
      setLoaded(true);
    } else {
      setUrls(null);
      setError(data.message);
    }

    setLoading(false);
  }

  useEffect(() => {
    setLoaded(false);
  }, [video]);

  useEffect(() => {
    if (video && !loaded && user !== null) {
      fetchUrls(video, token);
    }
  }, [video, loaded, user, token]);

  return {
    urls: urls ?? [],
    refresh: fetchUrls,
    loading,
    error,
  };
}
